import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DataResolverService } from '../resolver/data-resolver.service';
import { TabsDriverPage } from './tabs-driver.page';

const routes: Routes = [
  {
    path: '',
    component: TabsDriverPage,
    children: [
      {
        path: '',
        redirectTo: '/tecservice-driver/stops',
        pathMatch: 'full',
      },
      {
        path: 'stops',
        children: [
          {
            path: '',
            loadChildren: () => import('./stops/stops.module').then((m) => m.StopsPageModule),
          },
          {
            path: 'scan',
            children: [
              {
                path: '',
                loadChildren: () => import('./scan-driver/scan-driver.module').then((m) => m.ScanDriverPageModule),
              },
            ],
          },
          {
            path: 'scan-exit',
            children: [
              {
                path: '',
                loadChildren: () => import('./scan-driver/scan-driver.module').then((m) => m.ScanDriverPageModule),
              },
            ],
          },
          {
            path: ':id',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () => import('./stops/users/users.module').then((m) => m.UsersPageModule),
              },
            ],
          },
        ],
      },
      {
        path: 'scan',
        children: [
          {
            path: '',
            loadChildren: () => import('./scan-driver/scan-driver.module').then((m) => m.ScanDriverPageModule),
          },
        ],
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            loadChildren: () => import('../profile/profile.module').then((m) => m.ProfilePageModule),
          },
          {
            path: 'settings',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () => import('../register/register.module').then((m) => m.RegisterPageModule),
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () => import('../register/register.module').then((m) => m.RegisterPageModule),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsDriverPageRoutingModule {}
